<div class="listing-content-section">
  <div class="review-overall">
    <h3>Reviews</h3>
    <curbnturf-rating-display [rating]="rating" [count]="overallCount"> </curbnturf-rating-display>
  </div>
</div>
<div class="listing-content-section">
  <div *ngIf="!boondock" class="w-layout-grid reviews-grid">
    <div class="ratings-row">
      <div><strong>Quality</strong></div>
      <div class="review-rating-wrapper">
        <ngb-rating [rate]="ratingQuality" [max]="5" [readonly]="true"> </ngb-rating>
      </div>
    </div>
    <div class="ratings-row">
      <div><strong>Accuracy</strong></div>
      <div class="review-rating-wrapper">
        <ngb-rating [rate]="ratingAccuracy" [max]="5" [readonly]="true"> </ngb-rating>
      </div>
    </div>
    <div class="ratings-row">
      <div><strong>Check-In Experience</strong></div>
      <div class="review-rating-wrapper">
        <ngb-rating [rate]="ratingCheckIn" [max]="5" [readonly]="true"> </ngb-rating>
      </div>
    </div>
    <div class="ratings-row">
      <div><strong>Communication</strong></div>
      <div class="review-rating-wrapper">
        <ngb-rating [rate]="ratingCommunication" [max]="5" [readonly]="true"> </ngb-rating>
      </div>
    </div>
    <div class="ratings-row">
      <div><strong>Location</strong></div>
      <div class="review-rating-wrapper">
        <ngb-rating [rate]="ratingLocation" [max]="5" [readonly]="true"> </ngb-rating>
      </div>
    </div>
    <div class="ratings-row">
      <div><strong>Value</strong></div>
      <div class="review-rating-wrapper">
        <ngb-rating [rate]="ratingValue" [max]="5" [readonly]="true"> </ngb-rating>
      </div>
    </div>
  </div>
  <div *ngIf="boondock" class="w-layout-grid reviews-grid">
    <div class="ratings-row">
      <div><strong>Accuracy</strong></div>
      <div class="review-rating-wrapper">
        <ngb-rating [rate]="ratingAccuracy" [max]="5" [readonly]="true"> </ngb-rating>
      </div>
    </div>
    <div class="ratings-row">
      <div><strong>Location</strong></div>
      <div class="review-rating-wrapper">
        <ngb-rating [rate]="ratingLocation" [max]="5" [readonly]="true"> </ngb-rating>
      </div>
    </div>
  </div>
</div>
<div *ngFor="let ratingReview of overallRatings" class="listing-content-section">
  <div class="review-header">
    <div class="guest-content">
      <curbnturf-user-image [user]="ratingReview?.creator" [showName]="false"> </curbnturf-user-image>
      <div class="guest-copy">
        <div class="copy-regular">
          {{ ratingReview?.creator?.getShortName() }}
        </div>
        <div class="copy-light">
          {{ ratingReview?.created * 1000 | date : 'MMMM y' }}
        </div>
      </div>
    </div>
    <div class="review-outer">
      <div class="rating-inner">
        <curbnturf-rating-display [rating]="ratingReview?.score?.score"> </curbnturf-rating-display>
      </div>
    </div>
  </div>
  <div class="review-copy">
    <p>
      {{ ratingReview?.score?.description }}
    </p>
  </div>
</div>
